'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import config from '../../js/config';
import analytics from '../Analytics/Analytics';
var $global = require('../../js/globalElements');

var SecondaryNavigation = Backbone.View.extend({
  events: {
    'click .SecondaryNavigation-mobileToggle': 'toggleSecondaryNav',
    'click .SecondaryNavigation-list-item': 'toggleSecondaryNav'
  },

  initialize: function() {
    this.$tabList = this.$el.find('.SecondaryNavigation-tab');
    this.configuration = $('[data-secondary-navigation-configuration]').data('secondaryNavigationConfiguration');
    this.configureGATracking();
  },

  setAnalyticsAttributes: function($el, gaObj) {
    $el.attr(config.analytics.attributes.mandatory.event, gaObj.event);
    $el.attr(config.analytics.attributes.mandatory.action, gaObj.action);
    $el.attr(config.analytics.attributes.mandatory.category, gaObj.category);
    $el.attr(config.analytics.attributes.mandatory.label, $el.find('span').text().trim());
  },

  configureGATracking: function() {
    if (this.configuration && this.configuration.ga) {
      let overviewTab = this.$el.find('a.SecondaryNavigation-discover');
      let tabs = this.$el.find('a.SecondaryNavigation-list-item-link');

      if (this.configuration.ga.tabOverview) {
        this.setAnalyticsAttributes(overviewTab, this.configuration.ga.tabOverview);
        this.setAnalyticsAttributes($(tabs[0]), this.configuration.ga.tabOverview);
      }
      let numberOfTabs = tabs.length - 1;
      for (let tabNumber = 1; tabNumber <= numberOfTabs; tabNumber++) {
        if (this.configuration.ga['tab' + tabNumber]) {
          this.setAnalyticsAttributes($(tabs[tabNumber]), this.configuration.ga['tab' + tabNumber]);
        }
      }
    }
  },

  logAnalyticsEvent: function(e) {
    let $el = $(e.target);
    let $parent = $el.parent();
    let $link = null;

    if ($el.is('a')) {
      $link = $el;
    } else if ($parent.is('a')) {
      $link = $parent;
    }

    if ($link) {
      let event = $link.attr(config.analytics.attributes.mandatory.event);
      let category = $link.attr(config.analytics.attributes.mandatory.category);
      let action = $link.attr(config.analytics.attributes.mandatory.action);
      let label = $link.attr(config.analytics.attributes.mandatory.label);
      if (event && category && action && label) {
        analytics.pushToEventFramework({
          event,
          category,
          action,
          label
        });
      }
    }
  },

  addIsActive: function(e) {
    let $target = $(e.target);
    if ($target.closest(this.$tabList).hasClass(config.classes.isActive)) {
      return;
    }
    // remove all is-active from tabs
    this.$tabList.removeClass(config.classes.isActive);
    $target.closest(this.$tabList).addClass(config.classes.isActive);
  },

  toggleSecondaryNav: function(e) {
    e.preventDefault();
    // jQuery calls this function twice on mobile dropdown, this catches the differences
    // between the first, intended call and the second, unintended call
    let $delegateClassName = $(e.delegateTarget.className);
    if (!$delegateClassName.selector.indexOf('SecondaryNavigation')) {
      return;
    }
    let $target = $(e.currentTarget);
    if ($target.hasClass('SecondaryNavigation-list-item')) {
      this.addIsActive(e);
    }
    // For mobile, bubble up the selected category text
    // in place of "Toggle" so user knows which category they're navigating on
    if (config.breakpoints.phablet > $global.$window.width()) {
      let $toggleText = $target.find('.js-tab-label').html();
      this.$('.SecondaryNavigation-mobileToggle--text').html($toggleText);
    }

    this.$('.SecondaryNavigation-list').toggleClass('SecondaryNavigation-list--open');
    this.$('.Icon').toggleClass('is--inverted');
  },

  renderTabContent: function(e) {
    this.addIsActive(e);
    e.stopPropagation();
    let $target = $(e.currentTarget);

    if ($target.hasClass('SecondaryNavigation-discover-link-wrapper') || $target.hasClass('SecondaryNavigation-list-item--overview')) {
      this.$overviewPage.addClass(config.classes.isActive);
      this.$categoryPage.removeClass(config.classes.isActive);
    }
    else if ($target.hasClass('SecondaryNavigation-tab')) {
      // find tab # from secondary navigation
      let selectedTab = $target.data('category-tab');
      this.$overviewPage.removeClass(config.classes.isActive);
      this.$categoryPage.filter(':visible').removeClass(config.classes.isActive);
      // find correct category page that corresponds with tab clicked
      let selectedCategory = _.find(this.$categoryPage, (tabNumber) => {
        return $(tabNumber).data('tab-content') === selectedTab;
      });
      this.$selectedCategory = $(selectedCategory);
      this.$selectedCategory.addClass(config.classes.isActive);
    }
  }

});

SecondaryNavigation.extend = function(child) {
  let view = Backbone.View.extend.apply(this, arguments);
  view.prototype.events = _.extend({}, this.prototype.events, child.events);
  return view;
};

export function createSecondaryNavigation($parent) {
  new SecondaryNavigation({
    el: $parent.find('.SecondaryNavigation')
  });
}

export default SecondaryNavigation;



// WEBPACK FOOTER //
// ./assets/components/SecondaryNavigation/SecondaryNavigation.js